import { themr } from '@friendsofreactjs/react-css-themr';
import DebugContainer from './DebugContainer';

export default themr('ReferenceFront')(DebugContainer);
